import React, {useState} from 'react'
import {
  Row,
  Col,
  NavbarToggler as NavbarTogglerBase,
  NavLink as NavLinkBase,
  UncontrolledDropdown,
  DropdownToggle as DropdownToggleBase,
  DropdownMenu as DropdownMenuBase,
  Button,
  Input
} from 'reactstrap'
import styled from 'styled-components'
import Modal from 'ui/modal'
import ContactForm from 'containers/layouts/contact_form'
import { useTranslation } from 'react-i18next'
import {get} from 'lodash'
import poweredOcio from 'img/powered-ociobusiness-white-h'

const ContactLink = () => {
  const [isOpen, setIsOpen] = useState(false)
  const toggle = () => setIsOpen(!isOpen)
  const {i18n} = useTranslation()

  return (
    <React.Fragment>
      <a className="text-light" onClick={toggle} style={{cursor: 'pointer'}}>Contact</a>
      <Modal
        isOpen={isOpen}
        toggle={toggle}
        header={i18n.t('navbar.contact_link.modal_title')}
      >
        <ContactForm/>
      </Modal>
    </React.Fragment>
  )
}

const FooterSection = styled.div.attrs({
  className: ''
})`
  max-width: 280px;
  font-size: 0.95em;
  font-weight: 500;
  letter-spacing: normal;
  line-height: 30px;
  color: rgb(255 255 255 / 75%);
`

const Footer = (props) => {
  const {menu_props, user} = props
  const {root, footer_links, destination_link} = menu_props
  const {privacy, terms_and_conditions, merchant_terms_and_conditions} = footer_links
  const destinations = get(user, 'user_data.user.destinations') || get(user, 'user.destinations') || []

  return (
    <div className="text-white py-3 pb-3 pb-md-0" style={{background: '#363636'}}>
      <div className="container py-4">
        <Row>
          <Col className="d-flex justify-content-center justify-content-md-start p-0">
            <a href={root} className="text-white" style={{fontSize: '2em'}}>
              Indestinum
            </a>
          </Col>
        </Row>
        <Row className="py-4">
          <Col xs="12" sm="6" md="3" className="d-flex flex-column align-items-start mb-5 mb-md-0 px-5 px-md-0">
            <h3 className="mb-4">Top destinations</h3>
            <FooterSection>
              <ul className='list-unstyled m-0 p-0'>
                {destinations.map(({slug, name}) => {
                  return (
                    <li>
                      <a className="text-light" href={destination_link.replace(/ *\:[^)]*\: */g, slug)}>{name}</a>
                    </li>
                  )
                })}
              </ul>
            </FooterSection>
          </Col>
          <Col xs="12" sm="6" md="3" className="d-flex flex-column align-items-start mb-5 mb-md-0 px-5 px-md-0">
            <h3 className="mb-4">Support</h3>
            <FooterSection>
              <div>
                <p>Have any questions? Feel free to call us or drop us an email.</p>
              </div>
              <div>
                <i className="fa fa-envelope me-2" style={{opacity: '100', color: '#FFF'}}/><a className="text-light" href={"mailto:info@indestinum.com"}>info@indestinum.com</a>
              </div>
              <div className="mt-3">
                <i className="fa fa-phone me-2" style={{opacity: '100', color: '#FFF'}}/><a className="text-light" href={"tel:+34628531320"}>(+34) 628 53 13 20</a>
              </div>
            </FooterSection>
          </Col>
          <Col xs="12" sm="6" md="3" className="d-flex flex-column align-items-center align-items-md-start text-center">
            <h3 className="mb-4">Payment Methods</h3>
            <FooterSection>
              <div style={{fontSize: '2em'}}>
                <i className="fab fa-cc-visa me-2"/><i className="fab fa-cc-mastercard me-2"/><i className="fab fa-cc-amex"/>
              </div>
            </FooterSection>
          </Col>
          <Col xs="12" sm="6" md="3" className="d-flex flex-column align-items-start mb-5 mb-md-0 px-5 px-md-0">
            <h3 className="mb-4">InDestinum</h3>
            <FooterSection>
              <ul className='list-unstyled m-0 p-0'>
                <li>
                  <a className="text-light" href={terms_and_conditions.link}>{terms_and_conditions.label}</a>
                </li>
                <li>
                  <a className="text-light" href={merchant_terms_and_conditions.link}>{merchant_terms_and_conditions.label}</a>
                </li>
                <li>
                  <a className="text-light" href={privacy.link}>{privacy.label}</a>
                </li>
                <li>
                  <ContactLink/>
                </li>
              </ul>
              <div className="mt-3">
                <a
                  className="text-white text-decoration-none"
                  href="https://ociobusiness.es/"
                  target="_blank"
                  rel="noreferrer"
                >
                  Powered by{' '}
                  <img
                    src={poweredOcio}
                    height="20"
                    alt="OcioBusiness logo"
                    className="ms-1"
                  />
                </a>
              </div>
            </FooterSection>
          </Col>
        </Row>
      </div>
      <div className="mx-5" style={{borderTop: '1px solid #666', height: '5px'}}>

      </div>
      <div className="container px-0 py-2 font-weight-bold d-flex flex-column flex-md-row justify-content-between align-items-center">
        <div style={{fontWeight: '500'}}>
          © InDestinum - All rights reserved
        </div>
        <ul className='d-flex py-2 list-unstyled align-items-center align-self-center' style={{fontSize: '1.2em'}}>
          <li className='px-2'>
            <a href="" target="_blank" rel="noreferrer noopener">
              <i className="text-white fab fa-facebook"/>
            </a>
          </li>
          <li className='px-2'>
            <a href="" target="_blank" rel="noreferrer noopener">
              <i className="text-white fab fa-instagram"/>
            </a>
          </li>
        </ul>
      </div>
    </div>
  )
}

export default Footer
